import { createBasicIframe } from './Iframe-shared/createBasicIframe';

/**
 * Utility for creating an iframe that will not be visible to the user.
 * @param iframeUrl - The url to be used when creating the iframe
 */
export function createHiddenIframe(iframeUrl: URL) {
  // We create an iframe with some styles to make it hidden in order to load the service worker and relevant static content

  const iframe = createBasicIframe(/* title: empty string, since it's a hidden div anyway */ '');
  iframe.src = iframeUrl.href;
  iframe.style.display = 'none';
  iframe.style.height = '0';
  iframe.style.width = '0';

  return iframe;
}
